// extracted by mini-css-extract-plugin
export default {"button":"NewGroup_button__ICUKe","divider":"NewGroup_divider__OLHT4","link":"NewGroup_link__jMpQQ"};